<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar flat>
            <v-icon left color="accent">mdi-clipboard-text</v-icon>Sets
          <v-spacer></v-spacer>
        </v-toolbar>
        <set-list store="productSets/index" :headers="headers" :filters="{classification:null}"></set-list>
      </v-card>
    </div>
  </div>
</template>
<script>
import SetList from "@components/productSet/SetList.vue";

export default {
  components: {
    SetList
  },
  data() {
    return {
      headers: [
        { text: "Classification", value: "classification", align: "left" },
        { text: "Name", value: "name", align: "left" },
        { text: "Dominant Hand", value: "dominantHand" },
        { text: "Particle", value: "particleList" },
        { text: "Status", value: "status"},
        { text: "", value: "actions" }
      ]
    };
  }
};
</script>
